var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDomaTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3897 9.44779L22.6403 5.25412C22.2922 5.00027 21.8808 4.87533 21.4704 4.87873C21.06 4.87533 20.6485 5.00027 20.3005 5.25412L14.9995 9.12056C14.7375 9.31169 14.3812 9.31169 14.1192 9.12056L11.7002 7.35628C11.3521 7.10244 10.9409 6.9775 10.5303 6.98097C10.1198 6.9775 9.70866 7.10244 9.36038 7.35628L3.6109 11.55C3.01751 11.9828 2.66699 12.6717 2.66699 13.4047V26.4875C2.66699 26.8378 2.95163 27.1216 3.30264 27.1216H6.81379C7.16455 27.1216 7.44894 26.838 7.44894 26.488V15.7625C7.44894 15.4231 7.61128 15.1041 7.88622 14.904L10.1596 13.2478C10.27 13.1675 10.4005 13.1298 10.5303 13.133C10.6603 13.1298 10.7908 13.1675 10.9009 13.2478L13.1765 14.9055C13.4281 15.0887 13.5835 15.3725 13.6069 15.6799V26.4875C13.6069 26.8378 13.8918 27.1216 14.2428 27.1216H14.6731H17.3276H17.7579C18.1091 27.1216 18.3938 26.8378 18.3938 26.4875V13.5778C18.4172 13.2704 18.5725 12.9865 18.8241 12.8033L21.0997 11.1456C21.2099 11.0653 21.3406 11.0276 21.4704 11.0309C21.6002 11.0276 21.7307 11.0653 21.841 11.1456L24.1144 12.8018C24.3894 13.0019 24.5517 13.3209 24.5517 13.6603V26.4875C24.5517 26.8378 24.8364 27.1216 25.1876 27.1216H28.6978C29.049 27.1216 29.3337 26.8378 29.3337 26.4875V11.3026C29.3337 10.5695 28.9831 9.88062 28.3897 9.44779Z",
    fill: "#2A7DE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomaTitle);
export default __webpack_public_path__ + "static/media/doma-title.20cda66b105b6d4ef7241badfc6abaa9.svg";
export { ForwardRef as ReactComponent };